/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-unused-expressions */
// eslint-disable-next-line import/no-extraneous-dependencies
/* eslint-disable simple-import-sort/imports */
import { useTheme } from '@emotion/react';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import MenuIcon from '@mui/icons-material/Menu';
import {
  List,
  ListItem,
  ListItemText,
  Tooltip,
  useMediaQuery,
} from '@mui/material';
// eslint-disable-next-line import/no-extraneous-dependencies
import { styled } from '@mui/system';
import DrawerCard from 'components/DrawerCard';
import {
  NewMobileDocumentIcon,
  NewSelectedMobileDocumentIcon,
} from 'components/Icons/Document';
import { NewInboxIcon, NewSelectedInboxIcon } from 'components/Icons/InboxIcon';
import LogoutIcon from 'components/Icons/LogoutIcon';
import {
  NewMobileMessageIcon,
  NewSelectedMobileMessageIcon,
} from 'components/Icons/MobileMessageIcon';
import {
  NewPatientsRequestSelected,
  NewSelectedPatientsRequestSelected,
} from 'components/Icons/PatientsRequestSelected';
import ProfileIcon from 'components/Icons/ProfileIcon';
import TourGuide from 'components/TourGuide';
import { MyContext } from 'Context';
import { getLocalStorageItem } from 'hooks';
import process from 'process';
import {
  useAuthMe,
  useLogOutApiQuery,
  useSetIdelTimeQuery,
} from 'queries/AuthQueries';
import { useInboxListQuery } from 'queries/Patient';
import { useNotificationListApiQuery } from 'queries/Users';
import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { routes } from 'routes/RouteConstants';
import MessageUserHandlerService from 'utils/unreadMessageEmailService';
import FeedbackModal from 'components/Common/FeedbackModal';
import { ScribeNewSelectedIcon } from 'components/Icons/ScribeSelectedIcon';
import { ScribeNewIcon } from 'components/Icons/Scribe';
import SelectUserLogin from '../Common/SelectUserLogin';

const CustomTooltip = styled(Tooltip)({
  arrow: {
    '&:before': {
      backgroundColor: '#fff',
    },
    '&[data-popper-placement*="right"] .MuiTooltip-arrow': {
      left: 0,
    },
    '&[data-popper-placement*="left"] .MuiTooltip-arrow': {
      right: 0,
    },
    '&[data-popper-placement*="top"] .MuiTooltip-arrow': {
      bottom: 0,
    },
    '&[data-popper-placement*="bottom"] .MuiTooltip-arrow': {
      top: 0,
    },
  },
});

export default function Sidebar({
  options,
  toggel,
  setToggel,
  handleStroke,
  isSidebarMinimized,
  toggleSidebar,
}: any) {
  const classes = {
    root: {
      backgroundColor: 'white',
    },
    nested: {
      paddingLeft: '40px',
    },
    nestedSecondLevel: {
      paddingLeft: '80px',
    },
  };
  const { t } = useTranslation('sideTab');
  const navigate = useNavigate();
  const [isOpenMenuItems, setIsOpenMenuItems] = useState<boolean>(false);
  const [open, setOpen] = useState(false);
  const [openFeedbackModal, setOpenFeedbackModal] = useState<boolean>(false);
  const [navItemSelected, setNavItemSelected] = useState('');
  const { pathname } = useLocation();
  const { mutate: setIdelTime } = useSetIdelTimeQuery();
  const { mutate: logoutApi } = useLogOutApiQuery();
  const theme: any = useTheme();
  const underSm = useMediaQuery(theme.breakpoints.down('md'));
  const { dependentsList, setDependentsList, isDependent, dependentData } =
    useContext(MyContext);

  const dependents = JSON.parse(localStorage.getItem('dependents') || '');

  const handleOpenMenu = () => {
    setIsOpenMenuItems(true);
  };
  const handleCloseMenu = () => {
    setIsOpenMenuItems(false);
  };
  const handleOpenFeedbackMOdal = () => {
    setOpenFeedbackModal(true);
  };
  const handleCloseFeedbackMOdal = () => {
    setOpenFeedbackModal(false);
  };

  const handleClick = (NavigationItem: any) => {
    setOpen(!open);
    setNavItemSelected(NavigationItem.name);
  };
  const handleNavigate = (NavigationItem: any) => {
    navigate(NavigationItem.redirectLink);
    setNavItemSelected(NavigationItem.name);
  };

  const hanldeListItem = (NavigationItem: any) => {
    handleStroke(NavigationItem.name);
    handleNavigate(NavigationItem);
  };

  const {
    logout,
    isOpenGroupUiCard,
    setIsOpenGroupUiCard,
    isOpenUserUiCard,
    setIsOpenUserUiCard,
    chatClientData,
  } = useContext(MyContext);

  const { data: notificationsList, refetch } = useNotificationListApiQuery();

  // @ts-ignore
  chatClientData?.on((event: any) => {
    if (event?.total_unread_count !== undefined) {
      refetch();
    }
  });

  useEffect(() => {
    const eventSource = new EventSource(process.env.REACT_APP_BELL_URL || '');

    eventSource.onmessage = () => {
      refetch();
    };

    return () => {
      eventSource.close();
    };
  }, [refetch]);

  const handleLogout = () => {
    logoutApi(null, {
      onSuccess: () => {
        setIdelTime(
          {
            status: false,
          },
          {
            onSuccess: () => {
              logout();
              localStorage.clear();
              navigate(routes.LOGIN.pathname);
              window.location.reload();
            },
            onError: () => {},
          }
        );
      },
      onError: (err: any) => {},
    });
  };
  const userDetails = getLocalStorageItem('roles');
  const [userListFilters, setUserListFilters] = useState<any>({});
  const isPatient = userDetails?.roles?.includes('patient');
  const isScribe = userDetails?.scribe === true;

  const { data: inboxListApi } = useInboxListQuery(
    {
      userListFilters,
      userParams: {
        page: 1,
        pageSize: '4',
        status: 'NEW',
        sort: 'DESC',
        column: 'createdAt',
      },
    },
    userDetails?.uuid
  );

  const {
    firstName,
    lastName,
    picture,
    account: { logo },
  } = getLocalStorageItem('roles');
  const username = `${firstName} ${lastName}`;
  const image = getLocalStorageItem('profileImage');
  const { data: profileData } = useAuthMe();

  const { unreadCount, refetchInboxMessageUnreadCount } = useContext(MyContext);
  // const [unreadCount, setUnreadCount] = useState(0);

  // const { mutate: unreadMessageCount } = useUserUnreadMessageCount();

  useEffect(() => {
    refetchInboxMessageUnreadCount();
  }, []);

  const displayDrawerLinks = (NavigationItem: any, NavigationIndex: number) => {
    return (
      <div key={NavigationIndex} className="no-scrollbar">
        {isSidebarMinimized ? (
          <List
            component="nav"
            sx={{
              padding: `${underSm ? '' : '8px 16px'}`,
              boxSizing: 'border-box',
              gap: '8px',
            }}
            aria-labelledby="nested-list-subheader"
          >
            {NavigationItem && (
              <>
                <ListItem
                  id={NavigationItem.id}
                  className={
                    pathname.includes(NavigationItem.redirectLink)
                      ? `cursor-pointer rounded-md bg-secondary-200 ${
                          underSm
                            ? '!px-[8px]'
                            : 'flex items-center justify-center'
                        } hover:bg-secondary-200`
                      : `cursor-pointer rounded-md bg-secondary-100 ${
                          underSm ? '!px-[8px]' : ''
                        }  flex items-center justify-center hover:bg-secondary-200`
                  }
                  onClick={() => hanldeListItem(NavigationItem)}
                >
                  <Tooltip
                    title={NavigationItem.name}
                    arrow
                    placement="right"
                    PopperProps={{
                      popperOptions: {
                        modifiers: [
                          {
                            name: 'offset',
                            options: {
                              offset: [0, 30],
                            },
                          },
                        ],
                      },
                    }}
                  >
                    <div className="relative">
                      <span>
                        {pathname.includes(NavigationItem.redirectLink)
                          ? NavigationItem.selectedIcon
                          : NavigationItem.icon}
                      </span>
                      <div className="absolute right-[-8px] top-[-8px]">
                        {' '}
                        {(NavigationItem?.name === 'Inbox' ||
                          NavigationItem?.name === 'Requests' ||
                          NavigationItem?.name === 'Reception' ||
                          NavigationItem?.name === 'Messages') &&
                          // inboxListApi?.options?.totalElements > 0
                          unreadCount > 0 && (
                            <div className="flex h-[8px] w-[8px] items-center justify-center rounded-full bg-red-500 p-1 text-center text-xs text-white">
                              {unreadCount}
                              {/* {`${
                                inboxListApi?.options?.totalElements < 10
                                  ? inboxListApi?.options?.totalElements
                                  : '9+'
                              }`} */}
                            </div>
                          )}
                      </div>
                    </div>
                  </Tooltip>
                </ListItem>
              </>
            )}
          </List>
        ) : (
          <List
            component="nav"
            sx={{
              padding: `${underSm ? '' : '8px 16px'}`,
              boxSizing: 'border-box',
              gap: '8px',
            }}
            aria-labelledby="nested-list-subheader"
          >
            {NavigationItem && (
              <>
                <ListItem
                  id={NavigationItem.id}
                  className={
                    pathname.includes(NavigationItem.redirectLink)
                      ? `cursor-pointer rounded-md bg-secondary-200 ${
                          underSm ? '!px-[8px]' : ''
                        } hover:bg-secondary-200`
                      : `cursor-pointer rounded-md bg-secondary-100 ${
                          underSm ? '!px-[8px]' : ''
                        }  hover:bg-secondary-200`
                  }
                  // className="cursor-pointer rounded-md bg-[#101828] hover:bg-secondary-200"
                  // selcted={`${isItemSelected}`}
                  // sx={{
                  //   bgcolor:
                  //     link === NavigationItem?.name ? '#344054' : '#101828',
                  // }}
                  // sx={{
                  //   paddingLeft: "8px !important",
                  //   paddingRight: "8px !important",
                  // }}
                  onClick={() => hanldeListItem(NavigationItem)}
                >
                  {pathname.includes(NavigationItem.redirectLink) ? (
                    <span>{NavigationItem.selectedIcon}</span>
                  ) : (
                    <span>{NavigationItem.icon}</span>
                  )}

                  <ListItemText
                    sx={{
                      fontWeight: '600',
                      paddingLeft: '10px',
                      fontSize: '16px',
                      color: '#fff',
                    }}
                    primary={underSm ? '' : t(NavigationItem.name)}
                  />
                  {(NavigationItem?.name === 'Inbox' ||
                    NavigationItem?.name === 'Requests' ||
                    NavigationItem?.name === 'Reception' ||
                    NavigationItem?.name === 'Messages') &&
                    // inboxListApi?.options?.totalElements > 0
                    unreadCount > 0 && (
                      <div className="flex h-[10px] w-[10px] items-center justify-center rounded-full bg-red-500 p-1.5 text-center text-sm">
                        {unreadCount}
                        {/* {`${
                          inboxListApi?.options?.totalElements < 10
                            ? inboxListApi?.options?.totalElements
                            : '9+'
                        }`} */}
                      </div>
                    )}
                </ListItem>
              </>
            )}
          </List>
        )}
      </div>
    );
  };

  const displayMobileDrawerLinks = (
    NavigationItem: any,
    NavigationIndex: number
  ) => {
    const isItemSelected: any = navItemSelected === NavigationItem.name;
    const handleMobileListItem = (NavigationItemNew: any) => {
      'children' in NavigationItemNew
        ? () => handleClick(NavigationItemNew)
        : 'redirectLink' in NavigationItemNew
        ? () => handleNavigate(NavigationItemNew)
        : null;
    };

    return (
      <div key={NavigationIndex} className="no-scrollbar">
        <List
          component="nav"
          sx={{
            paddingTop: '8px',
            paddingBottom: '8px',
            paddingLeft: '2px',
            paddingRight: '0px',
            boxSizing: 'border-box',
          }}
          aria-labelledby="nested-list-subheader"
        >
          {NavigationItem && (
            <>
              <CustomTooltip
                title={NavigationItem.name}
                arrow
                placement="right"
              >
                <ListItem
                  id={NavigationItem.id}
                  className="cursor-pointer !px-[8px]"
                  sx={{
                    paddingLeft: '8px !important',
                    paddingRight: '8px !important',
                    backgroundColor: isItemSelected && '#F3F4F6',
                    '&:hover': {
                      transform: 'scale(1.2)',
                      transition: 'transform 0.2s ease-in-out',
                    },
                  }}
                  onClick={() => handleMobileListItem(NavigationItem)}
                >
                  {NavigationItem.icon}
                </ListItem>
              </CustomTooltip>
            </>
          )}
        </List>
      </div>
    );
  };

  useEffect(() => {
    // if active logged in user is dependent, it will automatically logout
    if (profileData?.data?.isdependent) {
      handleLogout();
    }
  }, [dependentData]);

  if (underSm) {
    return (
      <>
        <div className="fixed bottom-0 left-0 m-auto  flex max-h-[60px] w-full justify-evenly bg-[#11111F]">
          {isScribe && (
            <div
              className={`m-[7px] flex cursor-pointer items-center justify-center rounded-lg transition-all duration-100 ${
                pathname === (isPatient ? '/account' : '/scribe')
                  ? ' scale-105 '
                  : 'scale-100'
              } p-2`}
              onClick={() => {
                if (isOpenGroupUiCard) {
                  setIsOpenGroupUiCard(false);
                }
                if (isOpenUserUiCard) {
                  setIsOpenUserUiCard(false);
                }
                handleNavigate({
                  name: isPatient ? 'accounts' : 'scribe',
                  redirectLink: isPatient ? '/account' : '/scribe',
                });
              }}
            >
              <div
                className={`flex h-8 w-8 items-center justify-center rounded-lg transition-all duration-100 ${
                  pathname === '/scribe' ? ' scale-105 ' : 'scale-100'
                } p-2`}
              >
                <div>
                  {pathname.includes('account') ||
                  pathname.includes('scribe') ? (
                    <ScribeNewSelectedIcon />
                  ) : (
                    <ScribeNewIcon />
                  )}
                </div>
              </div>
            </div>
          )}
          {/* <div>{options?.map(displayDrawerLinks)}</div> */}
          {!isPatient && (
            <div
              className={`m-[7px] flex cursor-pointer items-center justify-center rounded-lg transition-all duration-100 ${
                pathname === '/messaging' ? ' scale-105 ' : 'scale-100'
              } p-2`}
              onClick={() => {
                handleNavigate({
                  name: 'Messaging',
                  redirectLink: '/messaging',
                });
              }}
            >
              {' '}
              {pathname === '/messaging' ? (
                // <div className={`flex h-8 w-8 items-center justify-center `}>
                <NewSelectedMobileMessageIcon />
              ) : (
                // </div>
                <>
                  {/* <div className={`flex h-8 w-8 items-center justify-center `}> */}
                  <NewMobileMessageIcon />
                  {/* </div> */}
                </>
              )}
            </div>
          )}
          <div
            className={`m-[7px] flex cursor-pointer items-center justify-center rounded-lg transition-all duration-100 ${
              pathname === (isPatient ? '/requests' : '/inbox')
                ? 'scale-105'
                : 'scale-100'
            } p-2`}
            onClick={() => {
              handleNavigate({
                name: isPatient ? 'Messages' : 'Inbox',
                redirectLink: isPatient ? '/requests' : '/inbox',
              });
            }}
          >
            {
              isPatient ? (
                pathname.includes('request') ? (
                  <NewSelectedPatientsRequestSelected />
                ) : (
                  <NewPatientsRequestSelected />
                )
              ) : // <div className={`flex h-8 w-8 items-center justify-center `}>
              // <NewInboxIcon />
              pathname === '/inbox' ? (
                <NewSelectedInboxIcon />
              ) : (
                <NewInboxIcon />
              )

              // </div>
            }
          </div>
          {isPatient && (
            <div
              className={`m-[7px] flex cursor-pointer items-center justify-center rounded-lg transition-all duration-100 ${
                pathname === (isPatient ? '/documents' : '')
                  ? 'scale-105'
                  : 'scale-100'
              } p-2`}
              onClick={() => {
                handleNavigate({
                  name: isPatient ? 'Documents' : '',
                  redirectLink: isPatient ? '/documents' : '',
                });
              }}
            >
              {pathname.includes('document') ? (
                <NewSelectedMobileDocumentIcon />
              ) : (
                <NewMobileDocumentIcon />
              )}
            </div>
          )}
          {profileData?.data?.account?.patientsAccessKey ? (
            <div
              className={`m-[7px] flex cursor-pointer items-center justify-center rounded-lg  p-2`}
            >
              <div
                className={
                  underSm
                    ? 'm-0 flex h-8 w-8 cursor-pointer items-center justify-center'
                    : 'cursor-pointer'
                }
                onClick={handleOpenMenu}
              >
                <MenuIcon
                  fontSize="large"
                  className="scale-95 text-primary-500"
                />
              </div>
            </div>
          ) : (
            <div
              className={`m-[7px] flex cursor-pointer items-center justify-center rounded-lg  p-2`}
            >
              <div
                className={
                  underSm
                    ? 'm-0 flex h-8 w-8 cursor-pointer items-center justify-center'
                    : 'cursor-pointer'
                }
                onClick={handleLogout}
              >
                <ExitToAppIcon fontSize="large" className="text-primary-500" />
              </div>
            </div>
          )}
          <DrawerCard
            isOpen={isOpenMenuItems}
            handleClose={handleCloseMenu}
            handleLogout={handleLogout}
            handleNavigate={handleNavigate}
            isProfileImage={image || picture !== null}
            imageLink={image || picture}
          />
        </div>
      </>
    );
  }

  return (
    <>
      <MessageUserHandlerService />
      {toggel ? (
        <div className={`flex h-full flex-col`}>
          <div className="absolute right-[-15px] top-[70px] m-0 ">
            <div
              onClick={toggleSidebar}
              className="relative z-30 flex cursor-pointer items-center justify-center rounded bg-white px-1 py-0.5 shadow-md transition-transform duration-300 ease-in-out hover:scale-110"
            >
              <KeyboardArrowLeftIcon
                className={`linear text-[#11111F] transition-transform duration-700 ${
                  isSidebarMinimized ? 'rotate-180' : 'rotate-0'
                }`}
                fontSize="small"
              />
            </div>
          </div>
          <List>{options?.map(displayDrawerLinks)}</List>

          <div
            className={`absolute bottom-0 my-4 ${
              isSidebarMinimized ? '!mb-[10px]' : ''
            } w-full border-x-0 border-b-0 border-t border-solid border-gray-700`}
          >
            <div
              className={`flex ${
                isSidebarMinimized ? 'flex-col' : 'items-center'
              } h-full justify-center gap-4 p-6`}
            >
              {/* {!isPatient &&
                (isSidebarMinimized ? (
                  <Tooltip
                    title="Feedback"
                    placement="right"
                    arrow
                    PopperProps={{
                      popperOptions: {
                        modifiers: [
                          {
                            name: 'offset',
                            options: {
                              offset: [0, 18],
                            },
                          },
                        ],
                      },
                    }}
                  >
                    <div
                      className="feedback_icon flex w-full cursor-pointer items-center justify-center"
                      onClick={handleOpenFeedbackMOdal}
                    >
                      <FeedbackOutlined
                        className="feedback_icon"
                        color="inherit"
                        sx={{ fontSize: 35 }}
                        style={{ fill: '#fff' }}
                      />
                    </div>
                  </Tooltip>
                ) : (
                  <div
                    className="flex cursor-pointer items-center justify-center"
                    onClick={handleOpenFeedbackMOdal}
                  >
                    <FeedbackOutlined
                      className="feedback_icon"
                      color="inherit"
                      sx={{ fontSize: 35 }}
                      style={{ fill: '#fff', marginTop: '5px' }}
                    />
                  </div>
                ))} */}
              {isSidebarMinimized ? (
                <Tooltip
                  title="Profile"
                  placement="right"
                  arrow
                  PopperProps={{
                    popperOptions: {
                      modifiers: [
                        {
                          name: 'offset',
                          options: {
                            offset: [0, 18],
                          },
                        },
                      ],
                    },
                  }}
                >
                  <div
                    id="profile-details-id"
                    className={`${
                      isSidebarMinimized && 'justify-center'
                    } flex w-full cursor-pointer`}
                    onClick={() => {
                      handleNavigate({
                        name: 'accounts',
                        redirectLink: '/account',
                      });
                    }}
                  >
                    <div className="flex items-center justify-center gap-3">
                      {image || picture !== null ? (
                        <img
                          src={image || picture}
                          alt="user-profile"
                          className="h-10 w-10 rounded-full object-cover"
                        />
                      ) : (
                        <div className="flex h-10 w-10 items-center justify-center">
                          <ProfileIcon />
                        </div>
                      )}
                    </div>
                  </div>
                </Tooltip>
              ) : (
                <div
                  id="profile-details-id"
                  className="flex w-full cursor-pointer"
                  onClick={() => {
                    handleNavigate({
                      name: 'accounts',
                      redirectLink: '/account',
                    });
                  }}
                >
                  <div className="flex items-center justify-center gap-3">
                    {image || picture !== null ? (
                      <img
                        src={image || picture}
                        alt="user-profile"
                        className="h-10 w-10 rounded-full object-cover"
                      />
                    ) : (
                      <div className="flex h-10 w-10 items-center justify-center">
                        <ProfileIcon />
                      </div>
                    )}
                    {!isSidebarMinimized && (
                      <>
                        <SelectUserLogin
                          username={username}
                          dependents={dependentsList}
                        />
                      </>
                    )}
                  </div>
                </div>
              )}

              {isSidebarMinimized ? (
                <Tooltip
                  title="Logout"
                  placement="right"
                  arrow
                  PopperProps={{
                    popperOptions: {
                      modifiers: [
                        {
                          name: 'offset',
                          options: {
                            offset: [0, 18],
                          },
                        },
                      ],
                    },
                  }}
                >
                  <div
                    className="flex w-full cursor-pointer items-center justify-center"
                    onClick={handleLogout}
                  >
                    <LogoutIcon />
                  </div>
                </Tooltip>
              ) : (
                <div
                  className="flex cursor-pointer items-center justify-center"
                  onClick={handleLogout}
                >
                  <LogoutIcon />
                </div>
              )}
            </div>
          </div>
          <TourGuide options={options} />
        </div>
      ) : (
        <div className="flex flex-col">
          <List>{options?.map(displayMobileDrawerLinks)}</List>
        </div>
      )}
      <FeedbackModal
        open={openFeedbackModal}
        handleClose={handleCloseFeedbackMOdal}
      />
    </>
  );
}
